export function isBase64(str) {
    return /^data:image\/(jpeg|png|jpg);base64,/.test(str);
}
//# sourceMappingURL=is-base64.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/utils/is-base64.js
// module id = 651
// module chunks = 4